import { WATCHER_IMAGES__add_to_loading_pool_from_collection_current } from './WATCHER_IMAGES__add_to_loading_pool_from_collection_current';
import { WATCHER_IMAGES__add_to_loading_pool_from_generation_current_graph } from './WATCHER_IMAGES__add_to_loading_pool_from_generation_current_graph';
import { WATCHER_IMAGES__add_to_loading_pool_from_generation_current_grid2d } from './WATCHER_IMAGES__add_to_loading_pool_from_generation_current_grid2d';

export function WATCHER_IMAGES__add_to_loading_pool() {
  return (
    <>
      <WATCHER_IMAGES__add_to_loading_pool_from_collection_current />
      <WATCHER_IMAGES__add_to_loading_pool_from_generation_current_graph />
      <WATCHER_IMAGES__add_to_loading_pool_from_generation_current_grid2d />
    </>
  );
}
